import { footerLinks, siteName } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="service-icon-wrap rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-2-line text-lg"></i>
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 text-xs md:text-sm text-background-200/80 leading-relaxed max-w-xl">
              本站为《善良的嫂子》剧情解析与人物关系梳理页面，内容以结局解读、剧情脉络与角色介绍为主，供观众交流参考。文中对结局的理解为基于公开信息的分析与观众讨论，不代表作品官方立场。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-4">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-xs md:text-sm text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] md:text-xs text-background-200/70">
            © {new Date().getFullYear()} {siteName} · 剧情解析整理
          </p>
          <p className="text-[11px] md:text-xs text-background-200/70">
            本站不提供任何影视播放内容，仅作剧情讨论与信息梳理
          </p>
        </div>
      </div>
    </footer>
  );
}